import React from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

const TABLE_SCROLL_Y = 360;

const SupplierReturnInvoiceList = ({ list, scrollY = TABLE_SCROLL_Y }) => {
	const columns = [
		{ title: "ID", dataIndex: "id", key: "id" },
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (date) => moment(date).format("DD/MM/YYYY"),
		},
		{ title: "Total Amount", dataIndex: "total_amount", key: "total_amount" },
		{ title: "Note", dataIndex: "note", key: "note" },
		{
			title: "Purchase Invoice No",
			dataIndex: "purchaseInvoice_id",
			key: "purchaseInvoice_id",
			width: 190,
			ellipsis: false,
			render: (purchaseInvoice_id) => (
				<Link to={`/purchase/${purchaseInvoice_id}`}>{purchaseInvoice_id}</Link>
			),
		},
	];

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	const table = (
		<Table
			scroll={{ x: 900, y: scrollY }}
			loading={!list}
			columns={columns}
			dataSource={list ? addKeys(list) : []}
			size="small"
		/>
	);

	return (
		<div className="sup-detail-section">
			<h5 className="sup-detail-section-heading">All Return Information</h5>
			<div className="detail-page-table-wrap">
				{table}
			</div>
		</div>
	);
};

export default SupplierReturnInvoiceList;
